<app-navbar></app-navbar>
<section class="focus">
  <div class="flex-container">
    <div class="flex-row flex-justify-center">
      <div class="flex-col-12">
        <div class="login-form">
          <div class="login-notification reset-password" *ngIf="tokenExpired">
            <img src="/assets/images/white-explanation-mark.svg" />
            <p>
              {{ 'reset_screen.token_expired' | translate }}
            </p>
          </div>

          <ng-container *ngIf="!success; else showSuccess">
            <h1 class="ds-title-1">{{ 'reset_screen.title' | translate }}</h1>
            <p class="ds-heading-2 subheading">{{ 'reset_screen.p' | translate }}</p>
            <form [formGroup]="resetForm" (ngSubmit)="resetPassword()">
              <div class="ds-form-row" [ngClass]="{ 'has-error': resetForm.get('email').invalid && resetForm.get('email').touched }">
                <label class="ds-ui-2" for="email">{{ 'reset_screen.email' | translate }}</label>
                <input
                  type="email"
                  formControlName="email"
                  class="ds-input"
                  [ngClass]="{ 'is-invalid': submitted && resetForm.get('email').invalid }"
                  [placeholder]="'placeholder.email' | translate"
                />
                <div *ngIf="resetForm.invalid && resetForm.touched" class="alert">
                  <div>{{ 'reset_screen.email_req' | translate }}</div>
                </div>
              </div>
              <app-ds-button variant="primary" width="auto" [isLoading]="loading" type="submit">
                {{ 'reset_pass.cta' | translate }}
              </app-ds-button>
            </form>
          </ng-container>
          <ng-template #showSuccess>
            <div class="reset-success">
              <app-ds-rounded-icon icon="mail-check" variant="success" size="large"></app-ds-rounded-icon>
              <div>
                <h1 class="ds-title-4">{{ 'reset_screen.title' | translate }}</h1>
                <p class="ds-heading-2" [innerHTML]="'reset_screen.email_sent' | translate: { email: email }"></p>
              </div>
            </div>
          </ng-template>
          <div class="links-wrapper">
            <p>
              <a routerLink="/login"> {{ 'reset_screen.back' | translate }}</a>
            </p>
          </div>
          <app-swiss-made-footer></app-swiss-made-footer>
        </div>
      </div>
    </div>
  </div>
</section>
